import fastdom from 'fastdom';

import { NonNullish } from 'utils/nullish-check';

class OverflowScroller {
  element: HTMLElement;
  lastKnownY: number = 0;
  currentTop: number = 0;
  initialTopOffset: number = 0;

  constructor(element: string | HTMLElement) {
    this.element =
      typeof element === 'string'
        ? NonNullish(document.querySelector<HTMLElement>(element))
        : element;

    if (!this.element) {
      return;
    }

    this.lastKnownY = window.scrollY;
    this.currentTop = 0;
    this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top, 10) || 0;
    this.attachListeners();
  }

  attachListeners() {
    window.addEventListener('scroll', this.checkPosition.bind(this));
  }

  checkPosition() {
    const thisRef = this;

    fastdom.measure(() => {
      const bounds = thisRef.element.getBoundingClientRect();
      const maxTop =
        bounds.top + window.scrollY - thisRef.element.offsetTop + thisRef.initialTopOffset;
      const minTop = thisRef.element.clientHeight - window.innerHeight;

      if (window.scrollY < thisRef.lastKnownY) {
        thisRef.currentTop -= window.scrollY - thisRef.lastKnownY;
      } else {
        thisRef.currentTop += thisRef.lastKnownY - window.scrollY;
      }

      thisRef.currentTop = Math.min(
        Math.max(thisRef.currentTop, -minTop),
        maxTop,
        thisRef.initialTopOffset,
      );
      thisRef.lastKnownY = window.scrollY;
    });

    fastdom.mutate(() => {
      thisRef.element.style.top = `${thisRef.currentTop}px`;
    });
  }

  destroy() {
    window.removeEventListener('scroll', this.checkPosition.bind(this));
  }
}

export default (element: string | HTMLElement) => new OverflowScroller(element);
